var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckSuggestionHotel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#0A936D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9.49994C17.25 9.71088 17.1562 9.89838 17.0156 10.039L11.0156 16.039C10.875 16.1796 10.6875 16.2499 10.5 16.2499C10.2891 16.2499 10.1016 16.1796 9.96094 16.039L6.96094 13.039C6.82031 12.8984 6.75 12.7109 6.75 12.4999C6.75 12.0781 7.07812 11.7499 7.5 11.7499C7.6875 11.7499 7.875 11.8437 8.01562 11.9843L10.5 14.4453L15.9609 8.98431C16.1016 8.84369 16.2891 8.74994 16.5 8.74994C16.8984 8.74994 17.25 9.07806 17.25 9.49994Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSuggestionHotel);
export default __webpack_public_path__ + "static/media/check-suggestion-hotel.758009a00e47667081db24b35076e851.svg";
export { ForwardRef as ReactComponent };